import { useQuery } from "@tanstack/react-query";
import {
  getRequestContractQueryOptions,
  mapDimCodeNameToSelectOption,
} from "./getRequestContractQueryOptions";

const useGetRequestContractModesOfTransportation = (
  cardCode: string | undefined,
  itemCode: string | undefined
) =>
  useQuery({
    ...getRequestContractQueryOptions(cardCode, itemCode),
    enabled: cardCode !== undefined && itemCode !== undefined,
    select: ({ data }) =>
      data?.ModeOfTransportations?.map(mapDimCodeNameToSelectOption),
  });

export default useGetRequestContractModesOfTransportation;
